export interface Observer<T> {
  next: (value: T) => void;
  complete: () => void;
  error: (err: unknown) => void;
}

export type NextValueObserver<T> = (value: T) => void;
export type PartialObserver<T> = Partial<Observer<T>>;

export type ObserverLike<T> = PartialObserver<T> | NextValueObserver<T>;

export const lift = <T>(observer: ObserverLike<T>): PartialObserver<T> => {
  if (typeof observer === 'function') {
    return { next: observer };
  }
  return observer;
};
